import styled from "@emotion/styled"
import { Box } from "@chakra-ui/react"

export const SelectTimeContainer = styled(Box)`
  .react-datepicker__input-container input {
    font-size: ${(props) =>
      props.fontSize ? props.fontSize : "var(--chakra-fontSizes-base)"};
  }
`
